/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalInfoCompanyDocument = {
  type: 'all-of',
  contains: [{
    type: 'CompanyDocument',
  }, {
    properties: {
      companyDocumentConfigName: {
        type: 'string',
        isRequired: true,
      },
    },
  }],
} as const;
